import React, { useState } from 'react';
import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  Dialog,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useUserPreferences } from '../../contexts/UserPreferencesContext';
import { getSnapshotFromOffer } from '../../utils/snapshotUtils';

const CurrencySelector = ({ offer = null, sx = {} }) => {
  const { t } = useTranslation();
  const { region: currentRegion, displayCurrency, setDisplayCurrency } = useUserPreferences();
  const [uahDialogOpen, setUahDialogOpen] = useState(false);

  // Determine what region to check
  if (offer !== null) {
    if (offer === undefined) {
      return null;
    }
    const snapshot = getSnapshotFromOffer(offer);
    if (snapshot?.region !== 'ua') {
      return null;
    }
  } else {
    if (currentRegion !== 'ua') {
      return null;
    }
  }

  const handleCurrencyChange = (_, newCurrency) => {
    if (newCurrency === null) return;
    if (offer !== null && newCurrency === 'UAH' && displayCurrency !== 'UAH') {
      setUahDialogOpen(true);
    }
    setDisplayCurrency(newCurrency);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ...sx }}>
      <Typography variant="body2" color="text.secondary" sx={{ minWidth: 'auto' }}>
        {t('currency.display', 'Currency')}:
      </Typography>
      <ToggleButtonGroup
        value={displayCurrency}
        exclusive
        onChange={handleCurrencyChange}
        size="small"
        sx={{
          '& .MuiToggleButton-root': {
            px: 1.5,
            py: 0.5,
            minWidth: '45px',
            fontSize: '0.75rem',
            fontWeight: 500,
            border: '1px solid',
            borderColor: 'divider',
            color: 'text.secondary',
            '&.Mui-selected': {
              backgroundColor: 'primary.main',
              color: 'primary.contrastText',
              '&:hover': {
                backgroundColor: 'primary.dark',
              }
            },
            '&:hover': {
              backgroundColor: 'action.hover',
            }
          }
        }}
      >
        <ToggleButton value="USD">
          USD
        </ToggleButton>
        <ToggleButton value="UAH">
          UAH
        </ToggleButton>
      </ToggleButtonGroup>

      <Dialog
        open={uahDialogOpen}
        onClose={() => setUahDialogOpen(false)}
        PaperProps={{
          sx: {
            borderRadius: 1,
            maxWidth: 400,
            mx: 2,
          },
        }}
      >
        <DialogContent sx={{ pt: 3, pb: 1, px: 3 }}>
          <Typography sx={{ fontFamily: "'Inter', sans-serif", fontSize: '0.9375rem', lineHeight: 1.6 }}>
            {t('currency.uahNote', 'Prices are set in dollars, payment is made in hryvnias at the exchange rate on the day of payment.')}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={() => setUahDialogOpen(false)}
            variant="contained"
            sx={{
              bgcolor: '#00c853',
              fontFamily: "'Manrope', sans-serif",
              fontWeight: 700,
              borderRadius: 1,
              textTransform: 'none',
              boxShadow: 'none',
              '&:hover': { bgcolor: '#00a040', boxShadow: 'none' },
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default CurrencySelector;